import { combineReducers } from 'redux'
import event from './event'
import project from './project'
import projects from './projects'
import users from './users'
import rootAppVars_INTERNAL from './pubsub'
import currentViewer from './current-viewer'
import debugging from './debugging'

export default combineReducers({
  event,
  project,
  projects,
  users,
  rootAppVars_INTERNAL,
  currentViewer,
  debugging,
})

